var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZetachainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 89,
    r: 89,
    fill: "#005741"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.109 108.673V120.693H62.5228C63.2068 112.782 65.7595 107.216 74.5873 99.389L112.109 67.3788V95.4683H125.616V43.79H48.8127V69.5498H62.3196V57.297H103.123L65.7843 89.1634L65.695 89.2476C50.0468 103.102 48.8027 114.284 48.8027 127.459V134.21H125.621V108.683H112.114L112.109 108.673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZetachainIcon);
export default __webpack_public_path__ + "static/media/zetachain-icon.849d61814e9171adfafb73f130615ba9.svg";
export { ForwardRef as ReactComponent };